import { postUploadMedia } from '../../utils/medias';
import { COMPANIES } from '../../providers/resources';
import { extractIdFromURI } from '../../utils/resources/ids';
import { getToken } from '../../utils/token';
import { HOMOLOGATION_MEDIA_TAG } from './constants';

const readFileAsDataUrl = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(String(reader.result || ''));
        reader.onerror = () => reject(new Error('file_read_failed'));
        reader.readAsDataURL(file);
    });

export const assertPdfFile = (file: File): void => {
    const isPdfMime = file.type === 'application/pdf';
    const isPdfName = file.name.toLowerCase().endsWith('.pdf');
    if (!isPdfMime && !isPdfName) {
        throw new Error('pdf_only');
    }
};

/**
 * Uploads a PDF homologation document attached to the fabricant company.
 * Returns the media UUID expected by prestataire affiliation endpoints.
 */
export async function uploadHomologationPdf(
    file: File,
    companyId: string,
    companyUri?: string
): Promise<string> {
    assertPdfFile(file);

    const token = getToken();
    if (!token) {
        throw new Error('missing_token');
    }

    const resourceId = extractIdFromURI(companyId) || companyId;
    const dataUrl = await readFileAsDataUrl(file);
    const apiV2Entrypoint = process.env.REACT_APP_API_V2_ENTRYPOINT;
    if (!apiV2Entrypoint) {
        throw new Error('missing_api_v2_entrypoint');
    }

    const response = await postUploadMedia(
        dataUrl as unknown as ArrayBuffer,
        file.name,
        COMPANIES,
        resourceId,
        token,
        'FILE',
        [HOMOLOGATION_MEDIA_TAG],
        companyUri,
        apiV2Entrypoint
    );

    const mediaId = extractIdFromURI(response?.id || response?.['@id'] || '');
    if (!mediaId) {
        throw new Error('upload_failed');
    }
    return mediaId;
}
